export const REQUEST_AUDIT_STATUS = "request_audit_status";
export const RECEIVE_AUDIT_STATUS = "receive_audit_status";
export const AUDIT_STATUS_ERROR = "audit_status_error";
export const REQUEST_AUDIT_STATUS_USER = "request_audit_status_user";
export const RECEIVE_AUDIT_STATUS_USER = "receive_audit_status_user";
export const AUDIT_STATUS_USER_ERROR = "audit_status_user_error";
export const REQUEST_AUTHORIZE_AUDIT = "request_authorize_audit";
export const RECEIVE_AUTHORIZE_AUDIT = "receive_authorize_audit";
export const AUTHORIZE_AUDIT_ERROR = "authorize_audit_error";
export const REQUEST_UNAUTHORIZE_AUDIT = "request_unauthorize_audit";
export const RECEIVE_UNAUTHORIZE_AUDIT = "receive_unauthorize_audit";
export const UNAUTHORIZE_AUDIT_ERROR = "unauthorize_audit_error";

import { getAuditStatus, getAuditStatusUser, authorizeAudit, unauthorizeAudit } from "src/actions/modelActions";

const getAuditStatusRedux = modelId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_AUDIT_STATUS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_AUDIT_STATUS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: AUDIT_STATUS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { audit, message } = await getAuditStatus(modelId);
			console.log("audit", audit);
			return onSuccess({ audit, message });
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};
const authorizeAuditRedux = (modelId, process_owner, process_id) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_AUTHORIZE_AUDIT,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_AUTHORIZE_AUDIT,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: AUTHORIZE_AUDIT_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await authorizeAudit(modelId, process_owner, process_id);
			return onSuccess(response);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};
const unauthorizeAuditRedux = (modelId, process_owner, process_id) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_UNAUTHORIZE_AUDIT,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_UNAUTHORIZE_AUDIT,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: UNAUTHORIZE_AUDIT_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await unauthorizeAudit(modelId, process_owner, process_id);
			return onSuccess(response);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const getAuditStatusUserRedux = modelId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_AUDIT_STATUS_USER,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_AUDIT_STATUS_USER,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: AUDIT_STATUS_USER_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { audit, message } = await getAuditStatusUser(modelId);
			return onSuccess({ audit, message });
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { getAuditStatusRedux, authorizeAuditRedux, unauthorizeAuditRedux, getAuditStatusUserRedux };
